<template>
  <v-container :fluid="$vuetify.breakpoint.mdAndDown">
    <v-row>
      <v-col cols="12">
        <h2 class="text-h4 font-weight-black">Migrants in Hong Kong</h2>
      </v-col>
      <v-col cols="12" sm="9">
        <p>
          This visualisation shows the period death rate of Hong Kong (natives,
          migrants, mainland migrants), Japan and high-income countries.
        </p>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card>
          <v-card-text>
            <!-- <p>
              Instructions: Please select the year (e.g. 2001) of interest.
              Hover over the bars to show exact figure breakdown.
            </p> -->
            <v-select
              rounded
              outlined
              v-model="selectedYear"
              :items="years"
              label="Select year"
            ></v-select>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="selectedYear">
        <v-img contain :src="migrants[`year${selectedYear}`]"></v-img>
        <p>Shaded area is the corresponding 95% confidence interval</p>
      </v-col>
      <!-- <v-col cols="12" v-if="selectedYear === '2016'">
      <v-img contain :src="migrants.mortality"></v-img>
      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>
import migrants from "../data/migrants";
export default {
  name: "Migrants",
  data: () => ({
    migrants,
    selectedYear: null,
    years: [
      {
        text: "2001",
        value: "2001",
      },
      {
        text: "2006",
        value: "2006",
      },
      {
        text: "2011",
        value: "2011",
      },
      {
        text: "2016",
        value: "2016",
      },
    ],
  }),
};
</script>
